/* =====================================================================
   AA SOCIAL PROOF ENGINE  —  assets/aa-proof-engine.js
   STANDALONE asset. Loaded by the "Social Proof Ribbon" section ONLY
   when the toggle is on. Self-contained (IIFE) — it does NOT touch
   custom.js and cannot affect any existing feature.
   Renders the living proof ribbon: live stats + real 5-star quotes,
   scrolling (always one line, every device). Lazy, fail-soft, cached.
   ===================================================================== */
(function () {
  'use strict';

  var AA_PROOF = {
    SUPABASE_URL: 'https://ksnfxryxrlmabxpuozaq.supabase.co',
    ANON_KEY:     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzbmZ4cnl4cmxtYWJ4cHVvemFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2MjAzNjEsImV4cCI6MjA4ODE5NjM2MX0.H0zoDHoSqwKoogQCBiLFeXWrG_Nuj1spk_0xGs-cw7c',
    BRAND:        'awareness_avenue',
    CACHE_TTL_MS: 6 * 60 * 60 * 1000,
    OBSERVE_MARGIN:'300px',
    SCROLL_PX_PER_SEC: 45
  };
  if (!AA_PROOF.ANON_KEY || AA_PROOF.ANON_KEY.indexOf('PASTE') !== -1) return;

  var mem = {};
  function cacheGet(k){ if(mem[k]!==undefined)return mem[k];
    try{var r=sessionStorage.getItem(k); if(!r)return null; var o=JSON.parse(r);
      if(Date.now()-o.t>AA_PROOF.CACHE_TTL_MS)return null; mem[k]=o.v; return o.v;}catch(e){return null;} }
  function cacheSet(k,v){ mem[k]=v; try{sessionStorage.setItem(k,JSON.stringify({t:Date.now(),v:v}));}catch(e){} }
  function rpc(fn,args){
    var k='aaproof:'+fn+':'+JSON.stringify(args||{}); var hit=cacheGet(k);
    if(hit!==null) return Promise.resolve(hit);
    return fetch(AA_PROOF.SUPABASE_URL+'/rest/v1/rpc/'+fn,{
      method:'POST',
      headers:{'apikey':AA_PROOF.ANON_KEY,'Authorization':'Bearer '+AA_PROOF.ANON_KEY,'Content-Type':'application/json'},
      body:JSON.stringify(args||{})
    }).then(function(r){return r.ok?r.json():Promise.reject(r.status);})
      .then(function(d){cacheSet(k,d);return d;});
  }

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function fmt(v,f){
    if(f==='dec1') return (Math.round(v*10)/10).toFixed(1);
    if(f==='pct1') return (Math.round(v*10)/10).toFixed(1)+'%';
    return String(Math.round(v));
  }
  function compactCount(n){ if(n==null)return''; if(n<1000)return String(n);
    return (Math.floor(n/1000)*1000).toLocaleString('en-US')+'+'; }
  function initials(name){
    var p=String(name||'').trim().split(/\s+/); if(!p[0])return '\u2605';
    return (p[0].charAt(0)+(p.length>1?p[p.length-1].charAt(0):'')).toUpperCase();
  }
  function statItem(s){
    return '<span class="aa-ribbon__stat">'
      +'<span class="aa-ribbon__num">'+esc(s.num)+'</span>'
      +(s.star?'<span class="aa-ribbon__star" aria-hidden="true">\u2605</span>':'')
      +'<span class="aa-ribbon__lbl">'+esc(s.lbl)+'</span></span>'
      +'<span class="aa-ribbon__dot" aria-hidden="true"></span>';
  }
  function revItem(r){
    return '<span class="aa-ribbon__rev">'
      +'<span class="aa-ribbon__mono" aria-hidden="true">'+esc(initials(r.reviewer))+'</span>'
      +'<span class="aa-ribbon__stars" aria-hidden="true">\u2605\u2605\u2605\u2605\u2605</span>'
      +'<span class="aa-ribbon__q">\u201C'+esc(r.quote)+'\u201D</span>'
      +'<span class="aa-ribbon__nm">'+esc(r.reviewer)+'</span></span>'
      +'<span class="aa-ribbon__dot" aria-hidden="true"></span>';
  }

  var renderers = {
    ribbon: function(el){
      var src = (window.__aaProof && window.__aaProof.then)
        ? window.__aaProof
        : rpc('aa_proof_ribbon',{p_brand:AA_PROOF.BRAND, p_limit:24});
      return src.then(function(p){
        var d=p.stats, revs=(p.highlights||[]);
        if(!d || !revs.length) throw 'no-data';
        var stats=[
          {num:fmt(d.avg_rating,'dec1'), star:true,  lbl:compactCount(d.review_count)+' Reviews'},
          {num:String(d.countries),      star:false, lbl:'Countries'},
          {num:fmt(d.pct_4_plus,'pct1'), star:false, lbl:'Rated 4 Stars or Higher'}
        ];
        var items=[], si=0;
        for(var i=0;i<revs.length;i++){
          items.push(revItem(revs[i]));
          if(i%2===1){ items.push(statItem(stats[si%stats.length])); si++; }
        }
        var unit=items.join('');
        el.innerHTML='<div class="aa-ribbon"><div class="aa-ribbon__track">'+unit+unit+'</div></div>';
        var track=el.querySelector('.aa-ribbon__track');
        var half=track.scrollWidth/2;
        if(half>0) track.style.animationDuration=Math.max(20,Math.round(half/AA_PROOF.SCROLL_PX_PER_SEC))+'s';
        el.setAttribute('data-aa-state','ready');
      });
    }
  };

  function hydrate(el){
    var fn=renderers[el.getAttribute('data-aa-proof')]; if(!fn) return;
    el.setAttribute('data-aa-state','loading');
    fn(el).catch(function(){ el.setAttribute('data-aa-state','empty'); el.style.display='none'; });
  }
  function init(){
    var nodes=document.querySelectorAll('[data-aa-proof]:not([data-aa-state])'); if(!nodes.length) return;
    if(!('IntersectionObserver' in window)){ Array.prototype.forEach.call(nodes,hydrate); return; }
    var io=new IntersectionObserver(function(entries,obs){
      entries.forEach(function(en){ if(en.isIntersecting){ obs.unobserve(en.target); hydrate(en.target); } });
    },{rootMargin:AA_PROOF.OBSERVE_MARGIN});
    Array.prototype.forEach.call(nodes,function(n){io.observe(n);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  window.AAProof={init:init,rpc:rpc};
})();